import React, { forwardRef } from 'react';
import { Slide } from '@material-ui/core';

const TransitionComponent = (props, ref) => <Slide direction="up" ref={ref} {...props} />;

export const Transition = forwardRef(TransitionComponent);
